/** Vuelidate instance name for session configurable fee fields in the CMS. */
export const SESSION_FEES_VUELIDATE_REGISTER_AS = "ConfigurableSessionPayments";
/** Payment settings change rarely, and ExpandingSection unmounts the panel so every expand refetches. */
export const OWNER_SUPPLEMENT_STALE_TIME_MS = 5 * 60 * 1000;
export const SESSION_FEE_NON_NEGATIVE_MESSAGE = "Fee amount must be $0 or greater.";
export const SESSION_FEE_PAYMENT_PROCESSING_DISABLED_MESSAGE =
  "Payment processing is disabled for the owning institution. Application Fee and Confirmation Deposit are set to $0 and can't be edited.";
export const SESSION_FEE_PAYMENT_SETTINGS_ERROR_MESSAGE =
  "Couldn't load the owning institution's payment settings. Verify the Application Fee and Confirmation Deposit before saving.";
export const SESSION_FEE_TOOLTIPS = {
  feeType: {
    application: "Student fee for application processing, not a part of the total program session price.",
    confirmation: "Student deposit applied to the program session price.",
  },
};
